var React = require('react');

function MessageSquare (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.29289322,16.2928932 C6.4804296,16.1053568 6.73478351,16 7,16 L19,16 C19.5522847,16 20,15.5522847 20,15 L20,5 C20,4.44771525 19.5522847,4 19,4 L5,4 C4.44771525,4 4,4.44771525 4,5 L4,18.5857864 L6.29289322,16.2928932 Z M7.41421356,18 L3.70710678,21.7071068 C3.07714192,22.3370716 2,21.8909049 2,21 L2,5 C2,3.34314575 3.34314575,2 5,2 L19,2 C20.6568542,2 22,3.34314575 22,5 L22,15 C22,16.6568542 20.6568542,18 19,18 L7.41421356,18 Z"}));
}

MessageSquare.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = MessageSquare;

MessageSquare.default = MessageSquare;
